import { styled } from 'stitches.config'

export const HeroRoot = styled('section', {
  width: '100%',
  background: '$secondary-500',
  color: '$accent-white',
})

export const HeroBox = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  position: 'relative',
  margin: 'auto',
  maxWidth: '500px',

  '@bp2': {
    flexDirection: 'row',
    maxWidth: '2400px',
  },
})

export const ImageColumn = styled('div', {
  width: '100%',
  maxWidth: '100%',
  lineHeight: 0,

  '@bp2': {
    width: '49.2%',
  },
})

export const ImageWrapper = styled('div', {
  width: '100%',
  aspectRatio: '1.88/1',
  position: 'relative',
  height: 'auto',
  objectPosition: 'unset',

  '@bp2': {
    aspectRatio: 'unset',
    height: '292px',
  },

  '@bp3': {
    aspectRatio: '2.02/1',
    height: 'auto',

    '& img': {
      objectPosition: '0% 50%',
    },
  },
})

export const CopyColumn = styled('div', {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '$2',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '$4 $2',

  '@bp2': {
    width: '50.8%',
    padding: '$3',
  },

  '@bp3': {
    padding: '$6',
  },
})

export const Header = styled('h1', {
  fontSize: '$h3',
  textAlign: 'center',
  width: '100%',
  lineHeight: '$h1',
  fontWeight: '$extraLight',
  '@bp2': {
    fontSize: '$h1',
    lineHeight: '$h1',
  },
})

export const Subheader = styled('h2', {
  fontFamily: '$primary',
  fontSize: '$body',
  textAlign: 'center',
  fontWeight: '$medium',
})
